import router from '../../router'
import moment from 'moment'

export const app = {
    mutations: {
        APP_STORAGE_SAVE() {},
        APP_STORAGE_LOAD() {}
    },
    actions: {
        saveState({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                this.$storage.getItem('appData').then(res => {
                    this.$storage
                        .setItem('appData', {
                            date: moment().format(),
                            version: process.env.PACKAGE_VERSION
                        })
                        .then(r => {
                            commit('APP_STORAGE_SAVE')
                            resolve(r)
                        })
                        .catch(error => {
                            console.error(error)
                            reject(new Error('Local storage "setItem" error'))
                            dispatch('resetState')
                        })
                })
            })
        },
        getState({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                this.$storage
                    .getItem('appData')
                    .then(response => {
                        if (response === null) {
                            dispatch('saveState').then(res => {
                                resolve(res)
                            })
                        } else if (
                            response.version === undefined ||
                            response.version !== process.env.PACKAGE_VERSION
                        ) {
                            if (response && response.version) {
                                console.log(
                                    `Storage old version: ${response.version}, app version: ${process.env.PACKAGE_VERSION}`
                                )
                            }
                            dispatch('resetState').then(() => {
                                router.push({ name: 'Home' }).catch(() => {})
                                resolve(response)
                            })
                            resolve(response)
                        }
                        commit('APP_STORAGE_LOAD')
                    })
                    .catch(error => {
                        console.error(error)
                        reject(new Error('Local storage "getItem" error'))
                    })
            })
        },
        resetState() {
            return new Promise((resolve, reject) => {
                this.$storage
                    .getItem('initialState')
                    .then(initialState => {
                        if (initialState) {
                            this.replaceState(initialState)
                        }
                        this.$storage.removeItem('selectedPromotions')
                        this.$storage.removeItem('selectedLabels')
                        this.$storage
                            .removeItem('appData')
                            .then(() => {
                                resolve()
                            })
                            .catch(e => {
                                console.error(e)
                                reject(new Error(e))
                            })
                    })
                    .catch(e => {
                        console.error(e)
                        reject(new Error(e))
                    })
            })
        },
        fetchAppData({ dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('getState')
                    .then(response => {
                        // check if data is not too old
                        if (!response || !response.date) {
                            dispatch('resetState').then(() => {
                                // router.push({ name: 'Home' }).catch(() => { })
                            })
                        }
                    })
                    .catch(error => {
                        console.error(error)
                        reject(new Error('Local storage error'))
                    })
            })
        }
    },
    getters: {}
}
